import {
  Paper,
  Stack,
  Typography,
  Box,
} from "@mui/material";

import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ForestIcon from "@mui/icons-material/Forest";

function EconomicImportance({ plant }) {
  if (!plant?.economic_importance) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        mt: 5,
        p: {
          xs: 3,
          md: 4,
        },
        borderRadius: 5,
        background:
          "linear-gradient(135deg,#FFFFFF,#F8FBFC)",
        border: "1px solid #E4EDF2",
        boxShadow: "0 10px 30px rgba(11,60,93,.08)",
      }}
    >
      {/* Header */}

      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        mb={3}
      >
        <Box
          sx={{
            width: 55,
            height: 55,
            borderRadius: "50%",
            bgcolor: "#EEF5FA",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <AccountBalanceWalletIcon
            sx={{
              color: "#0B3C5D",
            }}
          />
        </Box>

        <Box>
          <Typography
            sx={{
              fontSize: {
                xs: "1.5rem",
                md: "2rem",
              },
              fontWeight: 700,
              color: "#0B3C5D",
            }}
          >
            Economic Importance
          </Typography>

          <Typography
            sx={{
              color: "text.secondary",
              fontSize: 15,
            }}
          >
            Economic value, commercial applications and sustainable utilization
          </Typography>
        </Box>
      </Stack>

      {/* Accent Line */}

      <Box
        sx={{
          width: 90,
          height: 4,
          bgcolor: "#43A047",
          borderRadius: 10,
          mb: 3,
        }}
      />

      {/* Content */}

      <Typography
        sx={{
          textAlign: "justify",
          lineHeight: 2.1,
          color: "#555",
          fontSize: {
            xs: "1rem",
            md: "1.05rem",
          },
        }}
      >
        {plant.economic_importance}
      </Typography>

      {/* Information Note */}

      <Box
        sx={{
          mt: 4,
          p: 3,
          borderRadius: 4,
          bgcolor: "#F5FAF7",
          borderLeft: "5px solid #43A047",
          display: "flex",
          gap: 2,
          alignItems: "flex-start",
        }}
      >
        <ForestIcon
          sx={{
            color: "#2E7D32",
            mt: 0.3,
          }}
        />

        <Typography
          sx={{
            color: "#555",
            lineHeight: 1.9,
          }}
        >
          <strong style={{ color: "#0B3C5D" }}>
            Economic Note:
          </strong>{" "}
          This species contributes significantly to sustainable
          livelihoods through its applications in timber, herbal
          medicine, agroforestry, handicrafts, natural products,
          and environmental conservation. In addition to its
          commercial value, it plays an important role in
          biodiversity conservation, afforestation, soil
          stabilization, carbon sequestration, and ecological
          restoration, making it an important biological resource
          for sustainable development.
        </Typography>
      </Box>
    </Paper>
  );
}

export default EconomicImportance;